const Main = resolve => require(['@/components/main/Main.vue'], resolve);

//配件申请单
const PartApplyList = resolve => require(['@/module/partsApply/partsApplyListView.vue'], resolve);
const PartApplyEdit = resolve => require(['@/module/partsApply/partsApplyEditView.vue'], resolve);
const PartApplyDetail = resolve => require(['@/module/partsApply/partsApplyDetailView.vue'], resolve);

//服务站档案
const BasicDataEdit = resolve => require(['@/module/basicData/basicDataEditView.vue'], resolve);

//公告
const NoticeList = resolve => require(['@/module/notice/noticeList.vue'], resolve);
const NoticeView = resolve => require(['@/module/notice/noticeView.vue'], resolve);
//资料下载
const DatumList = resolve => require(['@/module/datum/datumList.vue'], resolve);
//文章详情
const kbarticleDetail = resolve => require(['@/module/datum/kbarticleDetail.vue'], resolve);


//签核角色
const FlowRoleList = resolve => require(['@/module/flow/flowRoleList.vue'], resolve);
const FlowRoleEdit = resolve => require(['@/module/flow/flowRoleEdit.vue'], resolve);
const FlowRoleCreateDetail = resolve => require(["@/module/flow/flowRoleCreateDetail.vue"], resolve);

//签核流程
const FlowList = resolve => require(["@/module/flow/flowList.vue"], resolve);
const FlowCreateDetail = resolve => require(["@/module/flow/flowCreateDetail.vue"], resolve);
const FlowDetail = resolve => require(["@/module/flow/flowDetail.vue"], resolve);


//配件发运
const PartsDispatchList = resolve => require(['@/module/partsDispatch/partsDispatchListView.vue'], resolve);
const PartsDispatchEdit = resolve => require(['@/module/partsDispatch/partsDispatchEditView.vue'], resolve);
const PartsDispatchDetail = resolve => require(['@/module/partsDispatch/partsDispatchDetailView.vue'], resolve);

//配件签收
const PartsSignList = resolve => require(['@/module/partsSign/partsSignListView.vue'], resolve);
const PartsSignEdit = resolve => require(['@/module/partsSign/partsSignEditView.vue'], resolve);

//配件销售
const NewOrderList = resolve => require(['@/module/newOrder/newOrderListView.vue'], resolve)
const NewOrderEdit = resolve => require(['@/module/newOrder/newOrderEditView.vue'], resolve)
const NewOrderDetail = resolve => require(['@/module/newOrder/newOrderDetailView.vue'], resolve)

//配件退货订单
const SiteReturnList = resolve => require(['@/module/siteReturn/siteReturnListView.vue'], resolve)
const SiteReturnEdit = resolve => require(['@/module/siteReturn/siteReturnEditView.vue'], resolve)


const PartsReturnList = resolve => require(['@/module/partsReturn/partsReturnListView.vue'], resolve);
const PartsReturnEdit = resolve => require(['@/module/partsReturn/partsReturnEditView.vue'], resolve);

const AmountAdjustList = resolve => require(['@/module/amountAdjustment/amountAdjustListView.vue'], resolve);
const AmountAdjustEdit = resolve => require(['@/module/amountAdjustment/amountAdjustEditView.vue'], resolve);


//费用结算单
const ExpenseClaimList = resolve => require(['@/module/expenseClaim/expenseClaimListView.vue'], resolve);
const ExpenseClaimEdit = resolve => require(['@/module/expenseClaim/expenseClaimEditView.vue'], resolve);

//服务管理
const WorkorderList = resolve => require(['@/module/service/workorderListView.vue'], resolve);
const WorkorderEdit = resolve => require(['@/module/service/workOrderEditView.vue'], resolve);

const WorkorderAssign = resolve => require(['@/module/service/mapAssignView.vue'], resolve);

//奖惩结算单
const claimFineList = resolve => require(['@/module/claimFine/claimFineListView.vue'], resolve);
const claimFineDetail = resolve => require(['@/module/claimFine/claimFineDetailView.vue'], resolve);

//额度调整流水
const AmountChangeLog = resolve => require(['@/module/amountChangeLog/amountChangeLog.vue'], resolve);
const AmountChangeLogLine = resolve => require(['@/module/amountChangeLog/amountChangeLogLine.vue'], resolve);

//配件库存查看
const SiteInvlist = resolve => require(['@/module/siteInv/siteInv.vue'], resolve);
const SiteInvLine = resolve => require(['@/module/siteInv/siteInvLine.vue'], resolve);

//配件库存流水
const partStockTransactionlist = resolve => require(['@/module/partStockTransaction/partStockTransaction.vue'], resolve);
const partStockTransactionline = resolve => require(['@/module/partStockTransaction/partStockTransactionLine.vue'], resolve);

//项目授权申请
const projectcreditList = resolve => require(['@/module/projectcredit/projectcreditListView.vue'], resolve)
const projectcreditEdit = resolve => require(['@/module/projectcredit/projectcreditEditView.vue'], resolve)

//配件借用单
const PartsBorrowList = resolve => require(['@/module/partsBorrow/partsBorrowListView.vue'], resolve)
const PartsBorrowEdit = resolve => require(['@/module/partsBorrow/partsBorrowEditView.vue'], resolve)
const PartsBorrowDetail = resolve => require(['@/module/partsBorrow/partsBorrowDetailView.vue'], resolve);

//线索报备
const LeadList = resolve => require(['@/module/lead/leadListView.vue'], resolve);
const leadCreateOrEdit = resolve => require(['@/module/lead/leadCreateOrEditView.vue'], resolve);

//线索登记表
const LeadReginsterList = resolve => require(['@/module/leadReginster/leadReginsterListView.vue'], resolve);
const LeadReginsterEdit = resolve => require(['@/module/leadReginster/leadReginsterEditView.vue'], resolve);

//技术外派
const pageFind = resolve => require(['@/module/technology/pageFindView.vue'], resolve);
//const new_expatriateEdit = resolve => require(['@/module/technology/edit.vue'],resolve);
//const expatriateEdit = resolve => require(['@/module/technology/edit.vue'],resolve);
const edit = resolve => require(['@/module/technology/edit.vue'], resolve);


//展会支持
const exhibitionSupport = resolve => require(['@/module/exhibitionsupport/exhibitionSupport.vue'], resolve);
const exedit = resolve => require(['@/module/exhibitionsupport/exedit.vue'], resolve);

//项目技术支持
const preprojectsupportList = resolve => require(['@/module/technology/preprojectsupportList.vue'], resolve);
const preprojectsupportEdit = resolve => require(['@/module/technology/preprojectsupportEdit.vue'], resolve);

//商机管理
const OpportunityList = resolve => require(['@/module/opportunity/opportunityList.vue'], resolve);
const OpportunityEdit = resolve => require(['@/module/opportunity/opportunityEdit.vue'], resolve);
const schemetypeEdit = resolve => require(['@/module/opportunity/schemetypeDialog.vue'], resolve);

//出货管理
const ShipmentList = resolve => require(['@/module/shipment/ShipmentList.vue'], resolve);
const ShipmentEdit = resolve => require(['@/module/shipment/ShipmentEdit.vue'], resolve);
const ShipmentLineEdit = resolve => require(['@/module/shipment/ShipmentLineEdit.vue'], resolve);
const ShipmentLineCreate = resolve => require(['@/module/shipment/ShipmentLineEdit.vue'], resolve);

//联系人
const ContactList = resolve => require(['@/module/contact/contactListView.vue'], resolve);
const ContactEdit = resolve => require(['@/module/contact/contactEditView.vue'], resolve);

//非标评审
const nonstandardauditList = resolve => require(['@/module/nonstandardaudit/list.vue'], resolve);
const nonstandardauditEdit = resolve => require(['@/module/nonstandardaudit/edit.vue'], resolve);
const nonstandardauditNewEdit = resolve => require(['@/module/nonstandardaudit/newEdit.vue'], resolve);
const nonstandardauditPrint = resolve => require(['@/module/nonstandardaudit/print.vue'], resolve);
const nonstandardSoftwareList = resolve=>require(['@/module/nonstandardaudit/software.vue'],resolve);

//下单/出货预测
const OrderorShipmentList = resolve => require(['@/module/OrderorShipment/OrderorShipmentList.vue'], resolve);
const OrderorShipmentEdit = resolve => require(['@/module/OrderorShipment/OrderorShipmentEdit.vue'], resolve);
const OrderorEdit = resolve => require(['@/module/OrderorShipment/OrderEdit.vue'], resolve);
const shipmentEdit = resolve => require(['@/module/OrderorShipment/ShipmentEdit.vue'], resolve);

//产品
const productD1List = resolve => require(['@/module/productD1/list.vue'], resolve);
const productD1Edit = resolve => require(['@/module/productD1/edit.vue'], resolve);

//开票申请
const applicationList = resolve => require(['@/module/application/applicationListView.vue'], resolve);
const applicationEdit = resolve => require(['@/module/application/applicationEditView.vue'], resolve);
const applicationEditDetail = resolve => require(['@/module/application/applicationEditDetail.vue'], resolve);


//开票申请首页
const deliverynoteList = resolve => require(['@/module/invoice/deliverynoteListView.vue'], resolve);
const invoiceEdit = resolve => require(['@/module/invoice/edit.vue'], resolve);
const invoiceApplicationList = resolve => require(['@/module/invoice/invoiceApplicationListView.vue'], resolve);
const deliverynotelineList = resolve => require(['@/module/invoice/deliverynotelineListView.vue'], resolve);
const invoiceDeliveryList = resolve => require(['@/module/invoice/invoiceDeliveryListView.vue'], resolve);
const invoiceDealerList = resolve => require(['@/module/invoice/invoiceDealerListView.vue'], resolve);
const invoiceDealerDetailListView = resolve => require(['@/module/invoice/invoiceDealerDetailListView.vue'], resolve);
// const applicationEdit = resolve => require(['@/module/application/applicationEditView.vue'], resolve);
// const applicationEditDetail = resolve => require(['@/module/application/applicationEditDetail.vue'], resolve);

//维修申请订单
const maintenceorderList = resolve => require(['@/module/maintenceorder/list.vue'], resolve);
const maintenceorderEdit = resolve => require(['@/module/maintenceorder/edit.vue'], resolve);
const maintenceorderitemEdit = resolve => require(['@/module/maintenceorder/editItem.vue'], resolve);
const maintenceorderlineView = resolve => require(['@/module/maintenceorder/lineView.vue'], resolve);
//维修申请订单报表
const QueryList = resolve => require(['@/module/maintenceorderquerylist/querylist.vue'], resolve);

//品质反馈
const qualityList = resolve => require(['@/module/quality/qualityListView.vue'], resolve);
const qualityEdit = resolve => require(['@/module/quality/qualityEditView.vue'], resolve);

//客户投诉
const complaintsList = resolve => require(['@/module/service/complaintsList.vue'], resolve);
const complaintsEdit = resolve => require(['@/module/service/complaintsEdit.vue'], resolve);

//经销商开票汇总单
const ticketsumList = resolve => require(['@/module/ticketsum/ticketsumList.vue'], resolve);
const ticketsumEdit = resolve => require(['@/module/ticketsum/ticketsumEdit.vue'], resolve);
const ticketsumDetails = resolve => require(['@/module/ticketsum/ticketsumDetails.vue'], resolve);

//客户接待
const receptionList = resolve => require(['@/module/reception/list.vue'], resolve);
const receptionEdit = resolve => require(['@/module/reception/edit.vue'], resolve);
const receptionLineEdit = resolve => require(['@/module/reception/editLine.vue'], resolve);

// 维修申请订单
const applymaintainorderList = resolve => require(['@/module/ordermaintain/list.vue'], resolve);
const applymaintainorderEdit = resolve => require(['@/module/ordermaintain/edit.vue'], resolve);
const maintainMaterialChose = resolve => require(['@/module/ordermaintain/chosematerial.vue'], resolve);
const maintainMakeOrderEdit = resolve => require(['@/module/ordermaintain/makeOrderEdit.vue'], resolve);

//工程服务申请
const applyserviceList = resolve => require(['@/module/applyservice/list.vue'], resolve);
///售后服务申请
const afterServiceList = resolve => require(['@/module/applyservice/afterService.vue'], resolve);
const applyserviceEdit = resolve => require(['@/module/applyservice/edit.vue'], resolve);

//跨区域工程项目
const crossprojectitemList = resolve => require(['@/module/crossprojectitem/list.vue'], resolve);
const crossprojectitemEdit = resolve => require(['@/module/crossprojectitem/edit.vue'], resolve);
const feedetailEdit = resolve => require(['@/module/crossprojectitem/feeDetailEdit.vue'], resolve);
const clientprojectEdit = resolve => require(['@/module/crossprojectitem/ClientprojectEdit.vue'], resolve);
const changeEdit = resolve => require(['@/module/crossprojectitem/changeEdit.vue'], resolve);
const feecountEdit = resolve => require(['@/module/crossprojectitem/FeeCountEdit.vue'], resolve);
const checkreceiveEdit = resolve => require(['@/module/crossprojectitem/CheckreceiveEdit.vue'], resolve);
const deliverEdit = resolve => require(['@/module/crossprojectitem/DeliverEdit.vue'], resolve);
const settleEdit = resolve => require(['@/module/crossprojectitem/SettleEdit.vue'], resolve);
const handoverEdit = resolve => require(['@/module/crossprojectitem/handoverEdit.vue'], resolve);
//跨区域项目协同
const cooperationApplicationList = resolve => require(['@/module/crossprojectitem/cooperationApplicationList.vue'], resolve);
const cooperationApplicationEdit = resolve => require(['@/module/crossprojectitem/cooperationApplicationEdit.vue'], resolve);
//
//服务人员
const SalesmanList = resolve => require(['@/module/salesman/salesmanList.vue'], resolve)
const SalesmanView = resolve => require(['@/module/salesman/SalesmanView.vue'], resolve)
const SalesmanEdit = resolve => require(['@/module/salesman/SalesmanEdit.vue'], resolve)

//客户
const accountList = resolve => require(['@/module/account/list.vue'], resolve);
const accountEdit = resolve => require(['@/module/account/edit.vue'], resolve);
const accountSearch = resolve => require(['@/module/account/searchList.vue'], resolve);

//跨区域服务费结算申请
const achievementapplyList = resolve => require(['@/module/achievementapply/list.vue'], resolve);
const achievementapplyEdit = resolve => require(['@/module/achievementapply/edit.vue'], resolve);
const projectsupportlineEdit = resolve => require(['@/module/achievementapply/projectsupportlineEdit.vue'], resolve);

//付款申请
const paymentapplyList = resolve => require(['@/module/paymentapply/list.vue'], resolve);
const paymentapplyEdit = resolve => require(['@/module/paymentapply/edit.vue'], resolve);
const servicecostEdit = resolve => require(['@/module/paymentapply/editService.vue'], resolve);
const technicalcostEdit = resolve => require(['@/module/paymentapply/editTechnical.vue'], resolve);
const pointcostEdit = resolve => require(['@/module/paymentapply/editPointcost.vue'], resolve);

//费用结算管理
const dealerCharge = resolve => require(['@/module/dealerCharge/main.vue'], resolve);
//函件管理
const dealerLetter = resolve => require(['@/module/dealerLetter/list.vue'], resolve);
//技术支持
const projectsupportbox = resolve => require(['@/module/projectsupportbox/list.vue'], resolve);
//项目技术支持申请(经销商V4.1)
const technicalSupportList = resolve => require(['@/module/technicalSupport/list.vue'], resolve);
const technicalSupportDetails = resolve => require(['@/module/technicalSupport/details.vue'], resolve);
//项目技术支持申请
const projectsupportList = resolve => require(['@/module/projectsupport/list.vue'], resolve);
const projectsupportEdit = resolve => require(['@/module/projectsupport/edit.vue'], resolve);
const details = resolve => require(['@/module/projectsupport/details.vue'], resolve);
//非标准项目技术支持申请
const noprojectsupportList = resolve => require(['@/module/projectsupport2/list.vue'], resolve);
const noprojectsupportEdit = resolve => require(['@/module/projectsupport2/edit.vue'], resolve);
const nodetails = resolve => require(['@/module/projectsupport2/details.vue'], resolve);

//跨区域业绩划拨利润
const expachievementapplytList = resolve => require(['@/module/expachievementapply/list.vue'], resolve);
const expachievementapplytEdit = resolve => require(['@/module/expachievementapply/edit.vue'], resolve);

//按次服务支持申请
const servicesupportList = resolve => require(['@/module/servicesupport/list.vue'], resolve);
const servicesupportEdit = resolve => require(['@/module/servicesupport/edit.vue'], resolve);

//标准订单
const standardorderlist = resolve => require(['@/module/standardorder/standardorderlist.vue'], resolve);
const standardorderedit = resolve => require(['@/module/standardorder/standardorderedit.vue'], resolve);
const standardorderdetails = resolve => require(['@/module/standardorder/stanfardorderdetails.vue'], resolve);

//配件订单
const partsorderlist = resolve => require(['@/module/partsorder/partsorderlist.vue'], resolve);
const partsorderedit = resolve => require(['@/module/partsorder/partsorderedit.vue'], resolve);
const partsorderdetails = resolve => require(['@/module/partsorder/partsorderdetalis.vue'], resolve);

//消息提醒
const businessmessagelist = resolve => require(['@/module/Businessmessage/businessmessageList.vue'], resolve);
const businessmessageedit = resolve => require(['@/module/Businessmessage/businessmessageEdit.vue'], resolve);

//配件/标准订单申请报表查询
const OrderStandardQueryList = resolve => require(['@/module/partsorstandard/querylist.vue'], resolve);
//标准/配件订单完工入库状态查询
const OrderStatusQuery = resolve => require(['@/module/partsorstandard/queryOrderStatus.vue'], resolve);

//标准/配件订单下单申请
const dealerorderList = resolve => require(['@/module/dealerorder/dealerorderListView.vue'], resolve);
const dealerorderEdit = resolve => require(['@/module/dealerorder/dealerorderEditView.vue'], resolve);
const dealerorderCertification = resolve => require(['@/module/dealerorder/dealerorderCertificationView.vue'], resolve);
const dealerorderPreAudit = resolve => require(['@/module/dealerorder/dealerorderPreAudit.vue'], resolve);

//客户项目信息
const accountprojectEdit = resolve => require(['@/module/accountproject/edit.vue'], resolve);
const accountprojectEquipmentReceive = resolve => require(['@/module/accountproject/equipmentReceive.vue'], resolve);
const accountprojectList = resolve => require(['@/module/accountproject/list.vue'], resolve);

const pjtItemList = resolve => require(['@/module/pjtItem/list.vue'], resolve);
const pjtItemView = resolve => require(['@/module/pjtItem/view.vue'], resolve);

//经销机构授信
const creditInfoList = resolve => require(['@/module/creditinfo/listView.vue'], resolve);
const creditApply = resolve => require(['@/module/creditinfo/applyView.vue'], resolve);
//经销机构账单
const dealerBillList = resolve => require(['@/module/dealerbill/listView.vue'], resolve);
const dealerBillDetails = resolve => require(['@/module/dealerbill/detailsView.vue'], resolve);
const dealerBillDelay = resolve => require(['@/module/dealerbill/delayView.vue'], resolve);
const dealerBillPreview = resolve => require(['@/module/dealerbill/detailsView.vue'], resolve);
const dealerBillDelayList = resolve => require(['@/module/dealerbill/delayListView.vue'], resolve);
//下单产品
const quoteProductDetails = resolve => require(['@/module/quoteProduct/detailsView.vue'], resolve);
//产品查询（新） add by sz_xx133
const quoteProductList = resolve => require(['@/module/quoteProduct/index.vue'], resolve);
//账户信息
const AccountInfoAccount = resolve => require(['@/module/accountinfo/account.vue'], resolve);
const AccountInfoBillDetail = resolve => require(['@/module/accountinfo/billDetail.vue'], resolve);
const AccountInfoTransAccount = resolve => require(['@/module/accountinfo/transAccount.vue'], resolve);
const AccountInfoCashDepositAccount = resolve => require(['@/module/accountinfo/cashDepositAccount.vue'], resolve);
const AccountInfoYearCreditAccount = resolve => require(['@/module/accountinfo/yearCreditAccount.vue'], resolve);
const AccountInfoTempCreditAccount = resolve => require(['@/module/accountinfo/tempCreditAccount.vue'], resolve);
const AccountInfoPersonalGuaranteeAccount = resolve => require(['@/module/accountinfo/personalGuaranteeAccount.vue'], resolve);
const AccountInfoDedicatedAccount = resolve => require(['@/module/accountinfo/dedicatedAccount.vue'], resolve);
const AccountInfoComplexCreditAccount = resolve => require(['@/module/accountinfo/complexCreditAccount.vue'], resolve);
const AccountInfoAccountRecharge = resolve => require(['@/module/accountinfo/accountRecharge.vue'], resolve);
const AccountInfoAccountRepayment = resolve => require(['@/module/accountinfo/accountRepayment.vue'], resolve);
const AccountInfoAccountPayment = resolve => require(['@/module/accountinfo/accountPayment.vue'], resolve);
const AccountInfoAccountRepaymentCredit = resolve => require(['@/module/accountinfo/accountRepaymentCredit.vue'], resolve);
//对账单
const CheckBillDealerCheckBill = resolve => require(['@/module/checkbill/dealerCheckBill.vue'], resolve);
//对账单详情
const billDetails = resolve => require(['@/module/checkbill/billDetails.vue'], resolve);
//账户资产
const AccountProperty = resolve => require(['@/module/accountProperty/list.vue'], resolve);
//现金账户
const comeAndGo = resolve => require(['@/module/accountProperty/comeAndGo.vue'], resolve);
//授信账户
const creditExtension = resolve => require(['@/module/accountProperty/creditExtension.vue'], resolve);
//保证金账户
const cashDeposit = resolve => require(['@/module/accountProperty/cashDeposit.vue'], resolve);

//收货账户
const shipmentAccount = resolve => require(['@/module/accountProperty/shipmentAccount.vue'], resolve);
const shipmentAccountPayDetail = resolve => require(['@/module/accountProperty/shipmentAccountPayDetail.vue'], resolve);
const shipmentAccountShipmentDetail = resolve => require(['@/module/accountProperty/shipmentAccountShipmentDetail.vue'], resolve);
const shipmentAccountUnshipmentDetail = resolve => require(['@/module/accountProperty/shipmentAccountUnshipmentDetail.vue'], resolve);

//对账
const dealerMonthBillDetail = resolve => require(['@/module/accountProperty/dealerMonthBillDetail.vue'], resolve);

//欠款收银台
const refundCashierDesk = resolve => require(['@/module/accountProperty/refundCashierDesk.vue'], resolve);
//充值收银台
const voucherCenter = resolve => require(['@/module/accountProperty/voucherCenter.vue'], resolve);
//服务订单
const serviceOrderForm = resolve => require(['@/module/serviceOrderForm/list.vue'], resolve);
//跨区域售后服务
const afterSaleServiceEdit = resolve => require(['@/module/serviceOrderForm/afterSaleServiceEdit.vue'], resolve);
//采购订单
const purchaseOrderForm = resolve => require(['@/module/purchaseOrderForm/list.vue'], resolve);
//请款记录
const appliedHistory = resolve => require(['@/module/dealerCharge/appliedHistory.vue'], resolve);
//分润结算记录
const appliedShareProfit = resolve => require(['@/module/fenrunqingkuan/appliedShareProfit.vue'], resolve);
//添加请款明细
const appliedEdit = resolve => require(['@/module/dealerCharge/appliedEdit.vue'], resolve);
//通讯录
const addressBook = resolve => require(['@/module/addressBook/list.vue'], resolve);
//分润请款
const fenrunqingkuan = resolve => require(['@/module/fenrunqingkuan/main.vue'], resolve);
//添加分润请款明细
const appliedChoose = resolve => require(['@/module/fenrunqingkuan/appliedChoose.vue'], resolve);

// 合同管理
const Contract = resolve => require(['@/module/contract/list.vue'], resolve);
const ContractDetail = resolve => require(['@/module/contract/detail.vue'], resolve);


export default [
  {
    path: '/salesman',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'SalesmanList',
        component: SalesmanList
      },
      {
        path: 'Edit/:id',
        name: 'SalesmanEdit',
        component: SalesmanEdit
      }, {
        path: 'view',
        name: 'SalesmanView',
        component: SalesmanView
      }
    ]
  },
  {
    path: "/flow",
    component: Main,
    children: [{
      path: "role",
      name: "FlowRoleList",
      component: FlowRoleList
    },
    {
      path: "createRoleDetail",
      name: "FlowRoleCreateDetail",
      component: FlowRoleCreateDetail
    },
    {
      path: "list",
      name: "FlowList",
      component: FlowList
    },
    {
      path: "createDetail",
      name: "FlowCreateDetail",
      component: FlowCreateDetail
    },
    {
      path: "roleedit/:id",
      name: "FlowRoleEdit",
      component: FlowRoleEdit
    },
    {
      path: "edit/:id",
      name: "FlowDetail",
      component: FlowDetail
    }
    ]
  },
  //服务单模块
  {
    path: '/workorder',
    component: Main,
    children: [{ //服务单主页面
      path: 'list',
      name: 'workorderlist',
      meta:{
        keepAlive: true//需要缓存页面状态
      },
      component: WorkorderList
    },
    {
      //服务单新增
      path: 'create/',
      name: 'workordercreate',
      component: WorkorderEdit
    },
    {
      path: 'edit/:id',
      name: 'workorderedit',
      component: WorkorderEdit,
    },
    {
      path: 'mapassign',
      name: 'mapassign',
      component: WorkorderAssign
    }
    ]
  },
  //结算奖惩单模块
  {
    path: '/claimFine',
    component: Main,
    children: [{ //主页面
      path: 'list',
      name: 'claimfine',
      component: claimFineList
    },
    {
      path: 'detail/:id',
      name: 'claimfinedetail',
      component: claimFineDetail,
    }
    ]
  },
  //配件申请模块
  {
    path: '/partsApply',
    component: Main,
    children: [{
      path: 'list',
      name: 'partlist',
      component: PartApplyList
    },
    {
      path: 'create/',
      name: 'partcreate',
      component: PartApplyEdit
    },
    {
      path: 'edit/:id',
      name: 'partedit',
      component: PartApplyEdit
    },
    ]
  },
  //项目授权申请
  {
    path: "/projectcredit",
    component: Main,
    children: [{
      path: "list",
      name: "projectcreditList",
      component: projectcreditList
    },
    {
      path: "edit/:id",
      name: "projectcreditEdit",
      component: projectcreditEdit
    },
    {
      path: "create",
      name: "projectcreditCreate",
      component: projectcreditEdit
    }
    ]
  },
  //配节借用单
  {
    path: "/partsBorrow",
    component: Main,
    children: [{
      path: "list",
      name: "partsBorrowList",
      component: PartsBorrowList
    },
    {
      path: "create",
      name: "partsBorrowcreate",
      component: PartsBorrowEdit
    },
    {
      path: "edit/:id",
      name: "partsBorrowedit",
      component: PartsBorrowEdit
    },
    {
      path: 'detailcreate/:id/:name/:type',
      name: 'partsBorrowdetailcreate',
      component: PartsBorrowDetail
    },
    {
      path: 'detailedit/:id/:type/:istrue',
      name: 'partsBorrowdetailedit',
      component: PartsBorrowDetail
    }
    ]
  },
  //配件签收
  {
    path: '/partsSign',
    component: Main,
    children: [{
      path: 'list',
      name: 'partssignlist',
      component: PartsSignList
    },
    {
      path: 'edit/:id',
      name: 'partssignedit',
      component: PartsSignEdit
    }
    ]
  },
  //配件库存查看
  {
    path: '/siteInv',
    component: Main,
    children: [{
      path: 'list',
      name: 'siteInvlist',
      component: SiteInvlist
    },
    {
      path: 'line/:row',
      name: 'siteInvLine',
      component: SiteInvLine
    }
    ]

  },
  //配件库存流水
  {
    path: '/partStockTransaction',
    component: Main,
    children: [{
      path: 'list',
      name: 'partStockTransactionlist',
      component: partStockTransactionlist
    },
    {
      path: 'line/:row',
      name: 'partStockTransactionline',
      component: partStockTransactionline
    }
    ]
  },
  //配件发售
  {
    path: '/newOrder',
    component: Main,
    children: [{
      path: 'list/',
      name: 'neworderlist',
      component: NewOrderList
    },
    {
      path: 'edit/:id',
      name: 'neworderedit',
      component: NewOrderEdit
    },
    {
      path: 'edit/',
      name: 'newordercreate',
      component: NewOrderEdit
    }
    ]
  },
  //配件退货
  {
    path: '/siteReturn',
    component: Main,
    children: [{
      path: 'list/',
      name: 'sitereturnlist',
      component: SiteReturnList
    },
    {
      path: 'edit/:id',
      name: 'sitereturnedit',
      component: SiteReturnEdit
    },
    {
      path: 'edit/',
      name: 'sitereturncreate',
      component: SiteReturnEdit
    }
    ]
  },

  //基础数据模块
  {
    path: '/basicData',
    component: Main,
    children: [{
      path: 'edit/',
      name: 'basiclist',
      component: BasicDataEdit
    },]
  },

  //发运单模块
  {
    path: '/partsDispatch',
    component: Main,
    children: [{
      path: 'list',
      name: 'dispatchlist',
      component: PartsDispatchList
    },
    {
      path: 'create/',
      name: 'dispatchcreate',
      component: PartsDispatchEdit
    },
    {
      path: 'edit/:id',
      name: 'dispatchedit',
      component: PartsDispatchEdit
    },
    {
      path: 'detailcreate/:id',
      name: 'dispatchdetailcreate',
      component: PartsDispatchDetail
    },
    {
      path: 'detailedit/:id',
      name: 'dispatchdetailedit',
      meta: {
        keepAlive: true
      },
      component: PartsDispatchDetail
    }
    ]
  },

  //旧件返厂
  {
    path: "/partsReturn",
    component: Main,
    children: [{
      path: "list",
      name: "PartsReturnList",
      component: PartsReturnList
    },
    {
      path: "edit/:id",
      name: "PartsReturnEdit",
      component: PartsReturnEdit
    },
    {
      path: "create/",
      name: "PartsReturnCreate",
      component: PartsReturnEdit
    }
    ]
  },

  // 额度调整单
  {
    path: "/amountAdjust",
    component: Main,
    children: [{
      path: "list",
      name: "AmountAdjustList",
      component: AmountAdjustList
    },
    {
      path: "create/",
      name: "AmountAdjustCreate",
      component: AmountAdjustEdit
    },
    {
      path: "edit/:id",
      name: "AmountAdjustEdit",
      component: AmountAdjustEdit
    }
    ]
  },
  //额度调整流水
  {
    path: "/amountChangeLog",
    component: Main,
    children: [{
      path: "list",
      name: "AmountChangeLog",
      component: AmountChangeLog
    },
    {
      path: "Line/:row",
      name: "AmountChangeLogLine",
      component: AmountChangeLogLine
    }
    ]
  },
  //费用调整单
  {
    path: "/expenseClaim",
    component: Main,
    children: [{
      path: "list",
      name: "ExpenseClaimList",
      component: ExpenseClaimList
    },
    {
      path: "edit/:id",
      name: "ExpenseClaimEdit",
      component: ExpenseClaimEdit
    }
    ]

  },
  //公告
  {
    path: "/notice",
    component: Main,
    children: [{
      path: "list",
      name: "NoticeList",
      component: NoticeList
    },
    {
      path: "view/:id",
      name: "NoticeView",
      component: NoticeView
    }
    ]
  },
  //资料下载
  {
    path: "/file",
    component: Main,
    children: [
      {
        path: "list",
        name: "DatumList",
        component: DatumList
      },
      {
        path: "view/:id",
        name: "kbarticleDetail",
        component: kbarticleDetail
      }

    ]
  },
  //线索报备模块
  {
    path: "/lead",
    component: Main,
    children: [{
      path: "list",
      name: "LeadList",
      component: LeadList
    },
    {
      path: "create",
      name: "leadCreate",
      component: leadCreateOrEdit
    },
    {
      path: "edit/:id",
      name: "leadEdit",
      component: leadCreateOrEdit
    },
    {
      path: "createFromLeadReginster/:leadReginsterId",
      name: "createFromLeadReginster",
      component: leadCreateOrEdit
    }
    ]
  },
  //线索登记表模块
  {
    path: "/leadReginster",
    component: Main,
    children: [{
      path: "list",
      name: "LeadReginsterList",
      component: LeadReginsterList
    },
    {
      path: "edit/:id",
      name: "LeadReginsterEdit",
      component: LeadReginsterEdit
    }]
  },
  //技术外派
  {
    path: '/expatriate',
    component: Main,
    children: [{
      path: "list",
      name: "pageFind",
      component: pageFind
    },
    {
      path: "edit/:id",
      name: "edit",
      component: edit
    },
    {
      path: "create",
      name: "expatriateCreate",
      component: edit
    },
    {
      path: "edit/:id/:type",
      name: "expatriateEdit",
      component: edit
    }
    ]
  },

  //展会支持
  {
    path: '/exhibitionsupport',
    component: Main,
    children: [{
      path: "list",
      name: "exhibitionSupport",
      component: exhibitionSupport
    },
    {
      path: "exeditcreate",
      name: "exedit",
      component: exedit
    },
    {
      path: "edit/:id",
      name: "exhibitionSupportEdit",
      component: exedit
    }
    ]
  },

  //联系人
  {
    path: '/contact',
    component: Main,
    children: [{
      path: 'list',
      name: 'ContactList',
      component: ContactList
    },
    {
      path: "create/:val",
      name: "ContactCreate",
      component: ContactEdit
    },
    {
      path: "edit/:id",
      name: "ContactEdit",
      component: ContactEdit
    }
    ]
  },
  //下单/出货预测
  {
    path: '/OrderorShipment',
    component: Main,
    children: [{
      path: 'list',
      name: 'OrderorShipmentList',
      component: OrderorShipmentList
    },
    {
      path: "OrderorShipmenteditcreate",
      name: "OrderorShipmentCreate",
      component: OrderorShipmentEdit
    },
    {
      path: "OrderorShipmentedit/:id",
      name: "OrderorShipmentEdit",
      component: OrderorShipmentEdit
    },
    {
      path: "Ordercreate/:id/:type/:name",
      name: "OrderCreate",
      component: OrderorEdit
    },
    {
      path: "Orderedit/:id/:type",
      name: "OrderEdit",
      component: OrderorEdit
    },
    {
      path: "Shipmentcreate/:id/:type/:name",
      name: "ShipmentCreate",
      component: shipmentEdit
    },
    {
      path: "Shipmentedit/:id/:type",
      name: "ShipmentEdit",
      component: shipmentEdit
    },
    ]
  },
  // //项目授权管理
  // {
  //   path: "/proJectcredit",
  //   component: Main,
  //   children: [
  //     {
  //       path: "list",
  //       name: "proJectcreditList",
  //       component: ProJectcreditList
  //     },
  //     {
  //       path: "edit/:id",
  //       name: "proJectcreditedit",
  //       component: ProJectcreditEdit
  //     },
  //     {
  //       path: "create",
  //       name: "projectcreditcreate",
  //       component: ProJectcreditEdit
  //     }
  //   ]
  // },
  //商机管理模块
  {
    path: '/opportunity',
    component: Main,
    children: [{
      path: 'list',
      name: 'opportunityList',
      component: OpportunityList,
    },
    {
      path: 'edit/:id',
      name: 'OpportunityEdit',
      component: OpportunityEdit,
    },
    {
      path: 'schemetypeCreate/:id/:name',
      name: 'schemetypeCreate',
      component: schemetypeEdit,
    },
    {
      path: 'schemetypeEdit/:schemetypeid/:status',
      name: 'schemetypeEdit',
      component: schemetypeEdit,
    }
    ]
  },
  //出货管理模块
  {
    path: '/shipment',
    component: Main,
    children: [{
      path: 'list',
      name: 'shipmentList',
      component: ShipmentList,
    },
    {
      path: 'edit/:id',
      name: 'shipmentEdit',
      component: ShipmentEdit,
    },
    {
      path: 'create',
      name: 'shipmentCreate',
      component: ShipmentEdit,
    },
    {
      path: 'shipmentLineEdit/:lineid/:edittype/:istrue',
      name: 'shipmentLineEdit',
      component: ShipmentLineEdit
    },
    {
      path: 'shipmentLineCreate/:shipmentid/:shipmentname/:type/:ordername/:orderid/:value',
      name: 'shipmentLineCreate',
      component: ShipmentLineCreate,
      meta: { keepAlive: false }
    }
    ]
  },
  //出货明细
  {
    path: 'shipmentLine',
    component: Main,
    children: [{
      path: 'edit/:id',
      name: 'shipmentLineEdit',
      component: ShipmentLineEdit
    }]
  },
  //非标评审
  {
    path: "/nonstandardaudit",
    component: Main,
    children: [{
      path: "list",
      name: "nonstandardauditList",
      component: nonstandardauditList,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    },
    {
      path: "edit/:id",
      name: "nonstandardauditEdit",
      component: nonstandardauditEdit
    },
    {
      path: "create",
      name: "nonstandardauditCreate",
      component: nonstandardauditEdit
    },
    {
      path: "newCreate",
      name: "nonstandardauditNewCreate",
      component: nonstandardauditNewEdit
    },
    {
      path: "newEdit/:id",
      name: "nonstandardauditNewEdit",
      component: nonstandardauditNewEdit
    },
    {
      path: "print/:id",
      name: "nonstandardauditPrint",
      component: nonstandardauditPrint
    },
    {
      path: "software",
      name: "nonstandardSoftwareList",
      component: nonstandardSoftwareList,
      meta:{
        keepAlive: false
      }
    },
    ]
  },
  //产品
  {
    path: '/productD1',
    component: Main,
    children: [
      {
      path: 'list',
      name: 'productD1List',
      component: productD1List,
    },
    {
      path: "productList",
      name: "quoteProductList",
      component: quoteProductList
    },
    {
      path: 'edit/:id',
      name: 'productD1Edit',
      component: productD1Edit,
    }
   
    ]
  },
  //开票申请
  {
    path: '/application',
    component: Main,
    children: [{
      path: 'list',
      name: 'applicationList',
      component: applicationList
    },
    {
      path: "create/",
      name: "applicationCreate",
      component: applicationEdit
    },
    {
      path: "edit/:id",
      name: "applicationEdit",
      component: applicationEdit
    }
    ]
  },
  //开票申请首页
  {
    path: '/invoice',
    component: Main,
    children: [{
      path: 'deliverynoteList',
      name: 'deliverynoteList',
      component: deliverynoteList
    },
    // {
    //   path: "create/",
    //   name: "applicationCreate",
    //   component: applicationEdit
    // },
    {
      path: "create",
      name: "invoiceCreate",
      component: invoiceEdit
    },
    {
      path: "edit/:id/:type",
      name: "invoiceEdit",
      component: invoiceEdit
    },
    {
      path: "invoiceApplicationList",
      name: "invoiceApplicationList",
      component: invoiceApplicationList
    },
    {
      path: "deliverynotelineList/:id",
      name: "deliverynotelineList",
      component: deliverynotelineList
    },
    {
      path: "invoiceDeliveryList",
      name: "invoiceDeliveryList",
      component: invoiceDeliveryList
    },
    {
      path: "invoiceDealerList",
      name: "invoiceDealerList",
      component: invoiceDealerList
    },
    {
      path: "invoiceDealerDetailListView/:invoiceMonth/:type",
      name: "invoiceDealerDetailListView",
      component: invoiceDealerDetailListView
    }
    ]
  },
  //开票申请明细
  {
    path: '/applicationdetail',
    component: Main,
    children: [{
      path: "create/:id/:name/:type",
      name: "CreateapplicationDetail",
      component: applicationEditDetail
    },
    {
      path: "edit/:id/:type/:istrue",
      name: "EditapplicationDetail",
      component: applicationEditDetail
    }
    ]
  },

  //维修申请订单
  {
    path: "/maintenceorder",
    component: Main,
    children: [{
      path: "list",
      name: "maintenceorderList",
      component: maintenceorderList
    },
    {
      path: "edit/:id",
      name: "maintenceorderEdit",
      component: maintenceorderEdit
    },
    {
      path: "create",
      name: "maintenceorderCreate",
      component: maintenceorderEdit
    },
    {
      path: "editItem/:id/:type/:istrue",
      name: "maintenceorderitemEdit",
      component: maintenceorderitemEdit
    },
    {
      path: "createItem/:id/:name/:type",
      name: "maintenceorderitemCreate",
      component: maintenceorderitemEdit
    },
    {
      path: "viewLine/:id",
      name: "maintenceorderlineView",
      component: maintenceorderlineView
    }
    ]
  },
  //维修申请订单报表
  {
    path: "/maintenceorderquerylist",
    component: Main,
    children: [{
      path: "list",
      name: "QueryList",
      component: QueryList
    },
    ]
  },
  //品质反馈
  {
    path: '/quality',
    component: Main,
    children: [{
      path: "list",
      name: "qualityList",
      component: qualityList
    },
    {
      path: "edit/:id",
      name: "qualityEdit",
      component: qualityEdit
    },
    {
      path: "create",
      name: "qualitycreate",
      component: qualityEdit
    }
    ]
  },

  //客户投诉
  {
    path: '/complaints',
    component: Main,
    children: [{
      path: "list",
      name: "complaintsList",
      component: complaintsList,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    },
    {
      path: "edit/:id",
      name: "complaintsEdit",
      component: complaintsEdit
    },
    {
      path: "create",
      name: "complaintsCreate",
      component: complaintsEdit
    }
    ]
  },

  //项目售前支持
  {
    path: '/preprojectsupport',
    component: Main,
    children: [{
      path: "list",
      name: "preprojectsupportList",
      component: preprojectsupportList
    },
    {
      path: "edit/:id",
      name: "preprojectsupportEdit",
      component: preprojectsupportEdit
    },
    {
      path: "create",
      name: "preprojectsupportCreate",
      component: preprojectsupportEdit
    }
    ]
  },
  //经销商开票汇总单
  {
    path: "/ticketsum",
    component: Main,
    children: [{
      path: "list",
      name: "ticketsumList",
      component: ticketsumList
    },
    {
      path: "edit/:id",
      name: "ticketsumEdit",
      component: ticketsumEdit
    },
    {
      path: "ticketsumDetails/:id",
      name: "ticketsumDetails",
      component: ticketsumDetails
    },
    ]
  },
  //客户接待
  {
    path: '/reception',
    component: Main,
    children: [{
      path: "list",
      name: "receptionList",
      component: receptionList
    },
    {
      path: "edit/:id",
      name: "receptionEdit",
      component: receptionEdit
    },
    {
      path: "create",
      name: "receptionCreate",
      component: receptionEdit
    },
    {
      path: "editLine/:id/:type/:istrue",
      name: "receptionLineEdit",
      component: receptionLineEdit
    },
    {
      path: "createLine/:id/:name/:type",
      name: "receptionLineCreate",
      component: receptionLineEdit
    },
    ]
  },

  // 维修申请订单
  {
    path: '/ordermaintain',
    component: Main,
    children: [{
      path: "list",
      name: "applymaintainorderList",
      component: applymaintainorderList
    }, {
      path: "newList",
      name: "newApplymaintainorderList",
      component: applymaintainorderList
    }, {
      path: "edit/:id",
      name: "applymaintainorderEdit",
      component: applymaintainorderEdit
    }, {
      path: "create",
      name: "applymaintainorderCreate",
      component: applymaintainorderEdit
    }, {
      path: "createMaterial/:id",
      name: "maintainMaterialChose",
      component: maintainMaterialChose
    }, {
      path: "makeOrderEdit/:id",
      name: "maintainMakeOrderEdit",
      component: maintainMakeOrderEdit
    }

      //maintainMakeOrderEdit
    ]
  },

  // 工程/售后服务申请
  {
    path: '/applyservice',
    component: Main,
    children: [{
      path: "list",
      name: "applyserviceList",
      component: applyserviceList
    },
    {
      path: "afterServiceList",
      name: "afterServiceList",
      component: afterServiceList
    },
    {
      path: "edit/:id/:type",
      name: "applyserviceEdit",
      component: applyserviceEdit
    },
    {
      path: "create/:type",
      name: "applyserviceCreate",
      component: applyserviceEdit
    },
    ]
  },
  // 跨区域工程项目
  {
    path: '/crossprojectitem',
    component: Main,
    children: [{
      path: "list",
      name: "crossprojectitemList",
      component: crossprojectitemList
    },
    {
      path: "edit/:id",
      name: "crossprojectitemEdit",
      component: crossprojectitemEdit
    },
    {
      path: "feedetailcreate/:itemid/:itemname/:blankcoefficient/:declaretravelamount",
      name: "feedetailCreate",
      component: feedetailEdit
    },
    {
      path: "feedetailedit/:id",
      name: "feedetailEdit",
      component: feedetailEdit
    },

    {
      path: "feecountedit/:id",
      name: "feecountEdit",
      component: feecountEdit
    },
    {
      path: "changecreate/:blankcoefficient/:itemid/:itemname",
      name: "changeCreate",
      component: changeEdit
    },
    {
      path: "changeedit/:id",
      name: "changeEdit",
      component: changeEdit
    },
    {
      path: "deliveredit/:id",
      name: "deliverEdit",
      component: deliverEdit
    },
    {
      path: "delivercreate",
      name: "deliverCreate",
      component: deliverEdit
    },

    {
      path: "checkreceiveedit/:id",
      name: "checkreceiveEdit",
      component: checkreceiveEdit
    },
    {
      path: "checkreceivecreate",
      name: "checkreceiveCreate",
      component: checkreceiveEdit
    },

    {
      path: "settleedit/:id",
      name: "settleEdit",
      component: settleEdit
    },
    {
      path: "settlecreate",
      name: "settleCreate",
      component: settleEdit
    },
    //settleEdit
    {
      path: "handoveredit/:id",
      name: "handoverEdit",
      component: handoverEdit
    },
    {
      path: "handovercreate",
      name: "handoverCreate",
      component: handoverEdit
    },
    {
      path: "clientprojectedit/:id",
      name: "clientprojectEdit",
      component: clientprojectEdit
    },
    {
      path: "cooperationApplicationList",
      name: "cooperationApplicationList",
      component: cooperationApplicationList
    },
    {
      path: "cooperationApplication/:id",
      name: "cooperationApplicationEdit",
      component: cooperationApplicationEdit
    }]
  },
  //客户信息
  {
    path: "/account",
    component: Main,
    children: [{
      path: "list",
      name: "accountList",
      component: accountList
    },
    {
      path: "edit/:id",
      name: "accountEdit",
      component: accountEdit
    },
    {
      path: "create",
      name: "accountCreate",
      component: accountEdit
    }
    ]
  },
  //跨区域服务费结算申请
  {
    path: "/achievementapply",
    component: Main,
    children: [{
      path: "list",
      name: "achievementapplyList",
      component: achievementapplyList
    },
    {
      path: "edit/:id",
      name: "achievementapplyEdit",
      component: achievementapplyEdit
    },
    {
      path: "create",
      name: "achievementapplyCreate",
      component: achievementapplyEdit
    },
    {
      path: "editLine/:id",
      name: "projectsupportlineEdit",
      component: projectsupportlineEdit
    }
    ]
  },
  //付款申请
  {
    path: "/paymentapply",
    component: Main,
    children: [{
      path: "list",
      name: "paymentapplyList",
      component: paymentapplyList
    },
    {
      path: "edit/:id",
      name: "paymentapplyEdit",
      component: paymentapplyEdit
    },
    {
      path: "create",
      name: "paymentapplyCreate",
      component: paymentapplyEdit
    },
    {
      path: "editService/:id/:type/:istrue",
      name: "servicecostEdit",
      component: servicecostEdit
    },
    {
      path: "createService/:id/:name/:type",
      name: "servicecostCreate",
      component: servicecostEdit
    },
    {
      path: "editTechnicalcost/:id/:type/:istrue",
      name: "technicalcostEdit",
      component: technicalcostEdit
    },
    {
      path: "createTechnicalcost/:id/:name/:type",
      name: "technicalcostCreate",
      component: technicalcostEdit
    },
    {
      path: "editPointcost/:id/:type/:istrue",
      name: "pointcostEdit",
      component: pointcostEdit
    },
    {
      path: "createPointcost/:id/:name/:type",
      name: "pointcostCreate",
      component: pointcostEdit
    },
    ]
  },
  //费用结算管理
  {
    path: "/dealerCharge",
    component: Main,
    children: [{
      path: "main",
      name: "dealerCharge",
      component: dealerCharge,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    }, {
      path: 'appliedHistory/:id',
      name: 'appliedHistory',
      component: appliedHistory
    },
    {
      path: 'appliedEdit/:id/:new_ordertype',
      name: 'appliedEdit',
      component: appliedEdit
    }
    ]
  },
  //函件管理
  {
    path: "/dealerLetter",
    component: Main,
    children: [{
      path: "list",
      name: "dealerLetter",
      component: dealerLetter
    }
    ]
  },
  //标准订单
  {
    path: "/standardorder",
    component: Main,
    children: [{
      path: "list",
      name: "standardorderlist",
      component: standardorderlist
    },
    {
      path: "edit/:id",
      name: "standardorderedit",
      component: standardorderedit
    },
    {
      path: "details/:mainid/:id",
      name: "standardorderdetails",
      component: standardorderdetails
    },
    ]
  },
  //配件订单
  {
    path: "/partsorder",
    component: Main,
    children: [{
      path: "list",
      name: "partsorderlist",
      component: partsorderlist
    },
    {
      path: "edit/:id",
      name: "partsorderedit",
      component: partsorderedit
    },
    {
      path: "details/:mainid/:id",
      name: "partsorderdetails",
      component: partsorderdetails
    },
    ]
  },
  //消息提醒
  {
    path: "/businessmessage",
    component: Main,
    children: [{
      path: "list",
      name: "businessmessagelist",
      component: businessmessagelist
    },
    {
      path: "edit/:id",
      name: "businessmessageedit",
      component: businessmessageedit
    },
    ]
  },
  //配件/标准订单申请报表
  {
    path: "/partsstandard",
    component: Main,
    children: [{
      path: "list",
      name: "OrderStandardQueryList",
      component: OrderStandardQueryList
    }, {
      path: "queryOrderStatus",
      name: "OrderStatusQuery",
      component: OrderStatusQuery
    }
    ]
  },
  //技术支持
  {
    path: "/projectsupportbox",
    component: Main,
    children: [{
      path: "list",
      name: "projectsupportbox",
      component: projectsupportbox,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    }]
  },
  //项目技术支持申请
  {
    path: "/projectsupport",
    component: Main,
    children: [{
      path: "list",
      name: "technicalSupportList",
      component: technicalSupportList
    },
    {
      path: "technicalSupportDetails/:id",
      name: "technicalSupportDetails",
      component: technicalSupportDetails
    },
    {
      path: "edit/:id",
      name: "projectsupportEdit",
      component: projectsupportEdit
    },
    {
      path: "details/:id/:supporttype",
      name: "details",
      component: details
    },
    {
      path: "detailscreate/:id/:type/:supporttype/:oppid",
      name: "detailscreate",
      component: details
    },
    {
      path: "create",
      name: "projectsupportCreate",
      component: projectsupportEdit
    },
    ]
  },
  //非标准项目技术支持申请
  {
    path: "/projectsupport2",
    component: Main,
    children: [{
      path: "list",
      name: "noprojectsupportList",
      component: noprojectsupportList
    },
    {
      path: "edit/:id",
      name: "noprojectsupportEdit",
      component: noprojectsupportEdit
    },
    {
      path: "details/:id/:supporttype",
      name: "nodetails",
      component: nodetails
    },
    {
      path: "detailscreate/:id/:type/:supporttype",
      name: "nodetailscreate",
      component: nodetails
    },
    {
      path: "create",
      name: "noprojectsupportCreate",
      component: noprojectsupportEdit
    },
    ]
  },
  //跨区域业绩划拨利润
  {
    path: "/expachievementapply",
    component: Main,
    children: [{
      path: "list",
      name: "expachievementapplytList",
      component: expachievementapplytList
    },
    {
      path: "edit/:id",
      name: "expachievementapplytEdit",
      component: expachievementapplytEdit
    },
    {
      path: "create",
      name: "expachievementapplytCreate",
      component: expachievementapplytEdit
    }
    ]
  },
  //按次服务支持申请
  {
    path: "/servicesupport",
    component: Main,
    children: [{
      path: "list",
      name: "servicesupportList",
      component: servicesupportList
    },
    {
      path: "edit/:id",
      name: "servicesupportEdit",
      component: servicesupportEdit
    },
    ]
  },
  //标准/配件订单下单申请
  {
    path: "/dealerorder",
    component: Main,
    children: [{
      path: "list",
      name: "dealerorderList",
      component: dealerorderList,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    },
    {
      path: "create",
      name: "dealerorderCreate",
      component: dealerorderEdit
    },
    {
      path: "edit/:id",
      name: "dealerorderEdit",
      component: dealerorderEdit
    },
    {
      path: "certification/:id",
      name: "dealerorderCertification",
      component: dealerorderCertification
    },
    {
      path:"preaudit/:id",
      name:"dealerorderPreAudit",
      component:dealerorderPreAudit
    },
    ]
  },
  //客户项目信息
  {
    path: "/accountproject",
    component: Main,
    children: [{
      path: "create/:opportunityid",
      name: "accountprojectCreate",
      component: accountprojectEdit
    },
    {
      path: "edit/:new_pjt_accountprojectid",
      name: "accountprojectEdit",
      component: accountprojectEdit
    },
    {
      path: "equipmentReceive",
      name: "accountprojectEquipmentReceive",
      component: accountprojectEquipmentReceive
    },
    {
      path: "list",
      name: "accountprojectList",
      component: accountprojectList
    },
    ]
  },
  //工程项目
  {
    path: "/pjtItem",
    component: Main,
    children: [{
      path: "list",
      name: "pjtItemList",
      component: pjtItemList
    }, {
      path: "view/:id",
      name: "pjtItemView",
      component: pjtItemView
    }]
  },
  //经销机构授信
  {
    path: "/creditinfo",
    component: Main,//dealerBillList
    children: [{
      path: "list",
      name: "creditInfoList",
      component: creditInfoList
    }, {
      path: "apply/:id",
      name: "creditApply",
      component: creditApply
    }]
  },
  //经销机构账单
  {
    path: "/dealerbill",
    component: Main,
    children: [{
      path: "list",
      name: "dealerBillList",
      component: dealerBillList
    }, {
      path: "details/:id",
      name: "dealerBillDetails",
      component: dealerBillDetails
    }, {
      path: "delaylist",
      name: "dealerBillDelayList",
      component: dealerBillDelayList
    }, {
      path: "delay/:id/:billid",
      name: "dealerBillDelay",
      component: dealerBillDelay
    }, {
      path: "details",
      name: "dealerBillPreview",
      component: dealerBillPreview
    }]
  },

  //账户信息
  {
    path: "/accountinfo",
    component: Main,
    children: [
      {
        path: "account",
        name: "AccountInfoAccount",
        component: AccountInfoAccount
      },
      {
        path: "billDetail/:tradetype",
        name: "AccountInfoBillDetail",
        component: AccountInfoBillDetail
      },
      {
        path: "transAccount",
        name: "AccountInfoTransAccount",
        component: AccountInfoTransAccount
      },
      {
        path: "cashDepositAccount",
        name: "AccountInfoCashDepositAccount",
        component: AccountInfoCashDepositAccount
      },
      {
        path: "yearCreditAccount",
        name: "AccountInfoYearCreditAccount",
        component: AccountInfoYearCreditAccount
      },
      {
        path: "tempCreditAccount",
        name: "AccountInfoTempCreditAccount",
        component: AccountInfoTempCreditAccount
      },
      {
        path: "personalGuaranteeAccount",
        name: "AccountInfoPersonalGuaranteeAccount",
        component: AccountInfoPersonalGuaranteeAccount
      },
      {
        path: "dedicatedAccount",
        name: "AccountInfoDedicatedAccount",
        component: AccountInfoDedicatedAccount
      },
      {
        path: "complexCreditAccount",
        name: "AccountInfoComplexCreditAccount",
        component: AccountInfoComplexCreditAccount
      },
      {
        path: "accountRecharge",
        name: "AccountInfoAccountRecharge",
        component: AccountInfoAccountRecharge
      },
      {
        path: "accountRepayment/:paytype",
        name: "AccountInfoAccountRepayment",
        component: AccountInfoAccountRepayment
      },
      /*  
      下单申请里老收银台
      {
         path: "accountPayment/:ordertype/:orderno/:orderamount",
         name: "AccountInfoAccountPayment",
         component: AccountInfoAccountPayment
       }, */
      {
        path: "accountRepaymentCredit",//:paytype
        name: "AccountInfoAccountRepaymentCredit",
        component: AccountInfoAccountRepaymentCredit
      },
    ]
  },
  //对账单
  {
    path: "/checkbill",
    component: Main,
    children: [
      {
        path: "dealerCheckBill",
        name: "CheckBillDealerCheckBill",
        component: CheckBillDealerCheckBill
      },
      {
        path: "Details/:billid",
        name: "billDetails",
        component: billDetails
      }
    ]
  },
  //账户资产
  {
    path: "/accountProperty",
    component: Main,
    children: [
      {
        path: "list",
        name: "AccountProperty",
        component: AccountProperty
      },
      {
        path: "comeAndGo",
        name: "comeAndGo",
        component: comeAndGo
      },
      {
        path: "creditExtension",
        name: "creditExtension",
        component: creditExtension
      },
      {
        path: "cashDeposit",
        name: "cashDeposit",
        component: cashDeposit
      },
      {
        path: "shipmentAccount",
        name: "shipmentAccount",
        component: shipmentAccount,
        meta:{
          keepAlive: true//需要缓存页面状态
        }
      },
      {
        path: "shipmentAccountPayDetail/:orderid",
        name: "shipmentAccountPayDetail",
        component: shipmentAccountPayDetail
      },
      {
        path: "shipmentAccountShipmentDetail/:orderid",
        name: "shipmentAccountShipmentDetail",
        component: shipmentAccountShipmentDetail
      },
      {
        path: "shipmentAccountUnshipmentDetail/:orderid",
        name: "shipmentAccountUnshipmentDetail",
        component: shipmentAccountUnshipmentDetail
      },

      {
        path: "dealerMonthBillDetail/:orderid",
        name: "dealerMonthBillDetail",
        component: dealerMonthBillDetail
      },

      {
        //path: "refundCashierDesk/:ordertype/:orderno/:orderamount", //金额暴露在地址栏不安全
        path: "refundCashierDesk",
        name: "AccountInfoAccountPayment",
        component: refundCashierDesk
      },
      {
        path: "voucherCenter",
        name: "voucherCenter",
        component: voucherCenter
      }
    ]
  },
  //下单产品
  {
    path: "/quoteproduct",
    component: Main,
    children: [{
      path: "details/:id",
      name: "quoteProductDetails",
      component: quoteProductDetails
    }]
  },
  //服务订单
  {
    path: '/serviceOrderForm',
    component: Main,
    children: [{
      path: 'list',
      name: "serviceOrderForm",
      component: serviceOrderForm
    },
    {
      path: 'afterSaleServiceEdit/:id',
      name: "afterSaleServiceEdit",
      component: afterSaleServiceEdit
    }]
  },
  //采购订单
  {
    path: '/purchaseOrderForm',
    component: Main,
    children: [{
      path: 'list',
      name: "purchaseOrderForm",
      component: purchaseOrderForm
    }]
  },
  //通讯录
  {
    path: '/addressBook',
    component: Main,
    children: [{
      path: 'list',
      name: "addressBook",
      component: addressBook
    }]
  },
  {
    path: '/fenrunqingkuan',
    component: Main,
    children: [{
      path: 'main',
      name: 'fenrunqingkuan',
      component: fenrunqingkuan,
    },
    {
      path: 'appliedShareProfit/:id',
      name: 'appliedShareProfit',
      component: appliedShareProfit
    },
    {
      path: 'appliedChoose/:id/:new_ordertype',
      name: 'appliedChoose',
      component: appliedChoose
    }
    ]
  },
  {
    path: "/contract",
    component: Main,
    children: [{
      path: "list",
      name: "optionService",
      component: Contract,
      meta:{
        keepAlive: true//需要缓存页面状态
      }
    }, {
      path: "detail",
      name: "optionService-detail",
      component: ContractDetail
    }]
  },
]



// WEBPACK FOOTER //
// ./src/module/router.js